/**
 * Tag-list helpers for the repeating metadata fields, kept separate so they can be tested.
 */

/**
 * Remove duplicate tags, comparing case-insensitively, keeping the first spelling seen.
 *
 * Device types arrive as ids (`APPLE_TV`) and were offered for selection by name (`Apple TV`), so picking
 * from the list next to an existing value left the same device twice — and the readable one was the entry
 * that failed validation. The option list stores ids now, and this stops a duplicate arriving either from
 * the list or from `freeSolo` typing.
 *
 * First-wins on purpose: the provider's spelling is the one already in the data, and replacing it with
 * ours would be an edit to a field the operator only clicked into. Blank tags are dropped, because an
 * Autocomplete will happily accept an empty chip.
 */
export const dedupeTags = (tags: string[]): string[] => {
  const seen = new Set<string>();

  return tags.filter((tag) => {
    const key = tag.trim().toLowerCase();
    if (!key || seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
};
